import React, {useEffect, useState} from "react";
import {Button, Pagination, RadioGroup, Tag, TextInput} from "omoplay";
import SuspensePopup from "../SuspensePopup";
import {
    getConfigMinPoint,
    getPointList,
    listPointUsers,
    savePoint,
    usingPoint
} from "../../api/point/point.api";
import NumberInput from "../NumberInput";
import GenericBoard from "../form/GenericBoard";

const PointUserListPage = () => {
    const [paginationUser, setPaginationUser] = useState({users: []});
    const [search, setSearch] = useState("");
    const [tempSearch, setTempSearch] = useState("");
    const [page, setPage] = useState(1);
    const [showSavePopup, setShowSavePopup] = useState(false)
    const [showUsePopup, setUsePopup] = useState(false)
    const [user, setUser] = useState({})
    const [sales, setSales] = useState("")
    const [point, setPoint] = useState("")
    const [pointType, setPointType] = useState("sales")
    const [minPoint, setMinPoint] = useState(1000)
    const [showHistoryPopup, setHistoryPopup] = useState(false)
    const [histories, setHistories] = useState([])

    useEffect(() => {
        listPointUsers(page, search).then(({data}) => {
            setPaginationUser(data)
        })
    }, [search, page]);

    useEffect(() => {
        getConfigMinPoint().then(({data}) => {
            if (data == null) {
                window.location.href = "/point/config"
                alert("포인트 설정을 해주세요.")
            } else {
                setMinPoint(data.minPoint)
            }
        })
    }, []);

    const headers = [
        { name: "이름", align: "center", width: "100px" },
        { name: "성별", align: "center", width: "80px" },
        { name: "생년월일", align: "center", width: "110px" },
        { name: "전화번호", width: "140px" },
        { name: "신규 전환 날짜", align: "center", width: "130px" },
        { name: "등급", align: "center", width: "100px" },
        { name: "포인트" },
    ];

    function userDetail(id) {
        window.location.href = `/user/detail?id=${id}`
    }

    const tableData = paginationUser.users.map(user => {
        return [
            <div className="flex-center-all h-full gap-2 text-primary pointer" onClick={() => userDetail(user.id)}>
              {user.name}
            </div>,
            <div className="flex-align-center h-full">
              <Tag className="text-white" color={user.gender === "남성" ? "#708090" : "#FFC0CB"}>{user.gender}</Tag>
            </div>,
            <div className="flex-col flex-center-all h-full gap-2">
              <div>{user.birthday}</div>
            </div>,
            <div className="flex-align-center h-full">{user.phoneNumber}</div>,
            <div className="flex-align-center text-center h-full">
              {user.createdAt}
            </div>,
            <div className="flex-center-all h-full gap-2">
                <div><Tag color="info">{user.grade}</Tag></div>
            </div>,
            <div className="flex-col h-full gap-2">
                <div className="text-[18px] text-primary">{user.point} 포인트</div>
                <div className="flex-align-center gap-2">
                    <div>
                        <Button variants="secondary" value="적립하기" onClick={() => {
                            setUser(user)
                            setSales("")
                            setPointType("sales")
                            setShowSavePopup(true)
                        }} />
                    </div>
                    <div>
                        <Button variants="primary" value="사용하기" onClick={() => {
                            setUser(user)
                            setPoint("")
                            setUsePopup(true)
                        }} />
                    </div>
                    <div>
                        <Button variants="default" value="내역보기" onClick={() => {
                            setUser(user)
                            setHistoryPopup(true)
                            getPointList(user.id, true).then(({data}) => {
                                setHistories(data)
                            })
                        }} />
                    </div>
                </div>
            </div>
        ]
    })

    return (
        <>
          <div className="flex-col rounded">
            <div className="flex items-start mt-[35px] gap-[24px]">
              <div className="max-w-[305px] w-[405px]">
                <div className="mb-[9px]">
                  <label className="search-label">검색어</label>
                </div>
                  <div className="flex-col gap-4">
                      <div className="flex-align-center gap-2">
                          <div className="flex-1">
                              <TextInput showIconSearch={true} value={tempSearch}
                                         onChange={(e) => setTempSearch(e.target.value)}
                                         onKeyUp={(e) => {
                                             if (e.key === "Enter") {
                                                 setPage(1)
                                                 setSearch(tempSearch)
                                             }
                                         }}
                                         style={{ height: "20px"}}
                              />
                          </div>
                          <Button variants="primary" size="large" value="검색" onClick={() => {
                              setPage(1)
                              setSearch(tempSearch)
                          }} />
                      </div>
                  </div>
              </div>
            </div>
            <div className="flex justify-between items-end mt-[30px] ml-[14px]">
              <span className="font-16px">
                총 <span className="text-primary">{paginationUser.totalCount?.toLocaleString()}</span>명
              </span>
            </div>
            <div className="flex-col py-4">
                <GenericBoard items={tableData} columns={[
                    { align: 'left', flex: true },
                    { align: 'left', flex: true },
                    { align: 'left', flex: true },
                    { align: 'left', flex: true },
                    { align: 'left', flex: true },
                    { align: 'left', flex: true }
                ]} />
              <div className="flex justify-center mt-[24px]">
                <Pagination pageSize={10} totalCount={paginationUser.totalCount} currentPage={page}
                            onPaging={(page) => setPage(page)} />
              </div>
            </div>
          </div>
            <SuspensePopup title="고객 적립" visible={showSavePopup}
                           onClose={() => setShowSavePopup(false)}
                           onConfirm={() => {
                               /*
                                 🔴 적립율을 **보내지 않는다** (2026-08-27). 서버가
                                    `PointHistoryService.resolveEarnRate` 로 등급을 직접 판정한다.

                                 종전에는 목록에서 받은 `user.rate` 를 되돌려 보냈다. 그래서
                                  ① 이 화면은 등급율이 적용되고 매장용(`/point/view`)은 채널 기본율만
                                    적용되어 **같은 고객이 화면에 따라 다른 포인트를 받았다**
                                  ② '고정 포인트' 채널은 `user.rate` 가 문자열 `"null"` 이라
                                    `rate: Float?` 역직렬화가 깨질 수 있었다(서버가 이제 JSON null 로
                                    내려주지만, 애초에 보낼 필요가 없는 값이다)
                                  ③ 프론트가 적립율을 정할 수 있다는 뜻이기도 했다
                               */
                               savePoint(sales, point, user.id, null, null, true).then(() => {
                                   alert("포인트가 적립되었습니다.")
                                   window.location.reload()
                               })
                           }}
                           confirmText="적립하기"
                           confirmDisabled={sales < 1000 && point < 10}
            >
                <div>
                    <div className="w-full flex-col">
                        <div className="flex-align-center gap-2">
                            <div className="text-[24px] font-semibold">{user.name}님</div>
                            <div className="text-[24px] font-semibold">({user.phoneNumber})</div>
                            {/* 적립율이 없는 채널(고정 포인트)에서는 표시를 생략한다 — 종전에는 `null%` 로 보였다 */}
                            {user.rate != null && (
                                <div className="text-[24px] font-semibold">{user.rate}%</div>
                            )}
                            <div className="text-[24px] font-semibold text-primary">적립</div>
                        </div>
                    </div>
                    <div className="w-[300px] mx-auto pt-[32px]">
                        <NumberInput onChangedNumber={(number) => {
                            if (pointType === "sales") {
                                setSales(number)
                            } else {
                                setPoint(number)
                            }
                        }} />
                    </div>
                    <div className="w-full flex-col items-end pr-[10px]">
                        <div className="flex-align-center gap-2">
                            <RadioGroup
                                items={[{label: "매출", value: "sales"}, {label: "포인트", value: "point"}]}
                                onSelected={(value) => {
                                    setPointType(value)
                                    setSales("")
                                    setPoint("")
                                }}
                                />
                            <div className="text-[32px] font-semibold">{pointType === "sales" ? "매출" : "포인트" }: </div>
                            <div className="text-[32px] font-semibold text-primary">
                                {
                                    pointType === "sales" ? `${Number(sales).toLocaleString()}원` : `${Number(point).toLocaleString()}포인트`
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </SuspensePopup>
            <SuspensePopup title="고객 포인트 사용" visible={showUsePopup}
                           onClose={() => setUsePopup(false)}
                           onConfirm={() => {
                               usingPoint(point, user.id, null, true).then(() => {
                                   alert("포인트가 사용되었습니다.")
                                   window.location.reload()
                               })
                           }}
                           confirmText="포인트 사용하기"
                           confirmDisabled={point < minPoint}
            >
                <div>
                    <div className="w-full flex-col">
                        <div className="flex-align-center gap-2">
                            <div className="text-[24px] font-semibold">{user.name}님</div>
                            <div className="text-[24px] font-semibold">({user.phoneNumber})</div>
                            <div className="text-[24px] font-semibold text-primary">사용</div>
                        </div>
                    </div>
                    <div className="w-[300px] mx-auto pt-[32px]">
                        <NumberInput onChangedNumber={(number) => setPoint(number)} />
                    </div>
                    <div className="w-full flex-col items-end pr-[10px]">
                        <div className="flex-align-center gap-2">
                            <div className="text-[32px] font-semibold">포인트: </div>
                            <div className="text-[32px] font-semibold text-primary">{Number(point).toLocaleString()}포인트</div>
                        </div>
                        {
                            point < minPoint && (<div className="text-red-500">최소 {minPoint}포인트 이상 사용해야 합니다.</div>)
                        }
                    </div>
                </div>
            </SuspensePopup>
            <SuspensePopup title="포인트 내역" visible={showHistoryPopup}
                           onClose={() => setHistoryPopup(false)}
            >
                <div>
                    <div className="w-full flex-col mb-4">
                        <div className="flex-align-center gap-2">
                            <div className="text-[24px] font-semibold">{user.name}님</div>
                            <div className="text-[24px] font-semibold">({user.phoneNumber})</div>
                            <div className="text-[24px] font-semibold text-primary">총 {user.point} 포인트</div>
                        </div>
                    </div>
                    <div className="flex-1 overflow-y-auto p-2 max-h-[325px] bg-grey-1">
                        {histories.length === 0 ? (
                            <div className="h-full flex items-center justify-center text-gray-400">내역이 없습니다.</div>
                        ) : (
                            <ul className="space-y-1">
                                {histories.map((item) => (
                                    <li className="flex justify-between items-center p-3 rounded-xl hover:bg-gray-50 border border-transparent hover:border-gray-100">
                                        <div>
                                            <div className="text-xs text-gray-500">{item.createdAt}</div>
                                            <span className="text-sm font-bold text-gray-700">{item.reason}</span>
                                        </div>
                                        <div className={`text-lg font-black ${item.point > 0 ? 'text-blue-600' : 'text-red-500'}`}>
                                            {item.point > 0 ? '+' : ''}{item.point.toLocaleString()} P
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </SuspensePopup>
        </>
    );
};
export default PointUserListPage;
